export default "__VITE_ASSET__B44wLIZ1__"